/* 🤖 this file was generated by svg-to-ts */
export const iconWarning: {
  name: 'warning';
  data: string;
} = {
  name: 'warning',
  data: `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g><path d="M8 2C4.691 2 2 4.691 2 8s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m0 14c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8"/><path d="M8 9a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1M8 12a.994.994 0 0 1-1-1c0-.13.03-.26.08-.38s.12-.23.21-.33c.05-.04.1-.09.16-.12.05-.04.11-.07.17-.09a.949.949 0 0 1 .76 0c.12.05.23.12.33.21.09.1.16.21.21.33a.995.995 0 0 1-.21 1.09A.994.994 0 0 1 8 12"/></g></svg>`,
};
